import { Controller } from "@hotwired/stimulus"

// Adiciona/remove linhas de variação (Tamanho, Cor...) no form de produto.
export default class extends Controller {
  static targets = ["rows", "template"]

  add() {
    const index = this.rowsTarget.children.length
    const html = this.templateTarget.innerHTML.replace(/NEW_INDEX/g, index)
    this.rowsTarget.insertAdjacentHTML("beforeend", html)
  }

  remove(event) {
    event.preventDefault()
    event.target.closest("[data-variation-row]").remove()
  }
}
